import { ref } from "vue";
type ToastType = "success" | "error" | "warning" | "info";
type ToastPosition = "top-right" | "top-left" | "bottom-right" | "bottom-left";

interface Toast {
  id: number;
  message: string;
  type: ToastType;
  timeout?: number;
}
const toasts = ref<Toast[]>([]);
const position = ref<ToastPosition>("top-right");
const defaultTimeout = 7000;

export function useToastStore() {
  const addToast = (
    message: string,
    type: ToastType = "info",
    timeout?: number
  ) => {
    const id = Date.now();
    toasts.value.push({
      id,
      message,
      type,
      timeout: timeout ?? defaultTimeout,
    });

    if (timeout !== 0) {
      setTimeout(() => {
        removeToast(id);
      }, timeout ?? defaultTimeout);
    }
  };

  const removeToast = (id: number) => {
    const index = toasts.value.findIndex((t) => t.id === id);
    if (index !== -1) {
      toasts.value.splice(index, 1);
    }
  };

  const success = (message: string, timeout?: number) =>
    addToast(message, "success", timeout);
  const error = (message: string, timeout?: number) =>
    addToast(message, "error", timeout);
  const warning = (message: string, timeout?: number) =>
    addToast(message, "warning", timeout);
  const info = (message: string, timeout?: number) =>
    addToast(message, "info", timeout);

  return {
    toasts,
    position,
    addToast,
    removeToast,
    success,
    error,
    warning,
    info,
  };
}
